module.exports = __webpack_public_path__ + "a1a371a4b03186bab79e8b020330a632.png";